/**
 * Created by guwenshuai 2019/8/15
 */
import http from '../libs/http'

//获取api列表
export const get_statistics = (key, value) => {
  return http.get({
    url: '/api/statistics/statistics',
    data: {
      params: {
        key,
        value
      }
    }
  }).then((res) => {
    return res;
  })
};
export const get_all_statistics = () => {
  return http.get({
    url: '/api/statistics/statistics',
    data: {
      params: {}
    }
  }).then((res) => {
    return res;
  })
};
export const post_statistics = (data) => {
  return http.post({
    url: '/api/statistics/statistics',
    data: {
      params: {
        data: data
      }
    }
  }).then((res) => {
    return res;
  })
};

export const put_change_statistics = (data) => {
  return http.put({
    url: '/api/statistics/statistics',
    data: {
      params: {
        data: data
      }
    }
  }).then((res) => {
    return res;
  })
}



// WEBPACK FOOTER //
// ./src/apis/statistics_apis.js